<template>
  <v-card>
    <v-card-title class="text-headline-small bg-grey-lighten-2" primary-title>
      {{ payload.material.materialName }}
    </v-card-title>
    <v-card-text>
      <v-text-field ref="cost" label="$" name="Coût" v-model="cost" type="number"></v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" variant="text" @click="cancel">Fermer</v-btn>
      <v-btn color="primary" variant="text" :disabled="cost <= 0" @click="confirm">
        Remplacer par sous-traitance
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { UpdateSubcontractingCost } from '@/_services/materials';
import { DialogPropsMixin } from '@/components/dialog/mixins';
import { stepperMixin } from '@/classes/helper/stepperHelper';

export default {
  name: 'MaterialSubcontractingDialog',
  mixins: [DialogPropsMixin, stepperMixin],
  data() {
    return {
      cost: null,
    };
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
    confirm() {
      this.$emit('loading');
      UpdateSubcontractingCost(this.payload.material.id, this.cost)
        .then(res => {
          this.$store.dispatch('job/updateMaterial', {
            compositeId: this.payload.compositeId,
            material: res,
            phaseId: this.payload.phaseId,
          });
        })
        .catch(error => {
          this.$store.dispatch('snackbar/set', error);
        })
        .finally(() => {
          this.updateTotalCost(this.$store.getters['submission/getJobId'])
            .catch(error => {
              this.$store.dispatch('snackbar/set', error);
            })
            .finally(() => {
              this.$emit('loading', false);
              this.$emit('close');
            });
        });
    },
  },
  mounted() {
    this.cost = this.payload.material.cost;
  },
};
</script>
